class CommandBase {
}
// This factory create model messages for the STTCommandMessage
export class CommandToMessageFactory {
    constructor() {
        this.commands = {};
        this.customParams = {};
    }
    setCustomParam(name, value) {
        this.customParams[name] = value;
    }
    getCustomParam(name) {
        return this.customParams[name];
    }
    register(cmd) {
        if (!this.commands[cmd.name]) {
            this.commands[cmd.name] = cmd;
        }
        else {
            console.warn(`[stt] Command already registered: ${cmd.name}`);
        }
    }
    parse(msg, messages) {
        const command = this.commands[msg.cmd];
        if (command) {
            return command.parse(this, msg, messages);
        }
        return false;
    }
}
